import React from "react";
import { useTranslation } from "react-i18next";

import { Button, Grid, InputAdornment, 
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import { Box } from "@mui/system";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "../../controls";
import { connect } from "react-redux";
import * as actions from "../../api/actions/pos";
import { controller, endpoints } from "../../api/actions/api";
import { NestedFormData, RmvEmptyProp } from "../../hooks/Method";
import { useContext } from "react";
import { AppContext } from "../../App";
import { safeOnComplete } from "../../utils/safeOnComplete";

const Refund = (props) => {
  const { t } = useTranslation();
  const {
    cartItems,
    setCartItems,
    tax,
    subTotal,
    setAlert,
    handleClearCart,
    setSelectedCustomer,
    _post,
    _get,
    _getById,
    _authUser,
    _store,
  } = props;
  const navigate = useNavigate();
  const [val, setVal] = useState("");
  const { setLoader } = useContext(AppContext);

  const [refundType, setRefundType] = useState(1); // 1 = Return Money
  const [refundPayType, setRefundPayType] = useState(1); // 1 = Cash

  const refreshInventory = React.useCallback(() => {
    if (!_store?.id) return;

    // Refresh Inventory page data
    _getById(
      endpoints.Inventory + controller.GetProdsByStore,
      _store.id,
      actions.ActionType.SetInventory
    );

    // Refresh POS Products "In Stock"
    _getById(
      endpoints.Product + controller.GetByStore,
      _store.id,
      actions.ActionType.SetProducts
    );
  }, [_store?.id, _getById]);

  const loadInvoice = () => {
    if (val === "") {
      setAlert({
        isOpen: true,
        type: "error",
        title: t("error"),
        subTitle: t("invoiceIdRequired"),
      });
      return;
    }

    setLoader(true);

    const onComplete = (res, err) => {
      safeOnComplete(
        (res) => {
          if (
            res.status === 200 &&
            res.result &&
            Number(res.result.storeId) === Number(_store.id)
          ) {
            setCartItems(res.result.sellItems || []);

            setSelectedCustomer(res.result.customer || null);
            
          } else {
            setCartItems([]);

            setAlert({
              isOpen: true,
              type: "warning",
              title: t("warning"),
              subTitle: t("invoiceNotFound"),
            });
          }
        },
        (err) => {
          setCartItems([]);

          setAlert({
            isOpen: true,
            type: "error",
            title: t("error"),
            subTitle: err?.msg || t("requestFailed"),
          });
        }
      )(res, err);

      setLoader(false);
    };

    _get(
      endpoints.Sell + controller.GetRefundableById  + "/" + val,
      null,
      onComplete
    );
  };

  const handleRefund = () => {
    if (val === "") {
      setAlert({
        isOpen: true,
        type: "error",
        title: t("error"),
        subTitle: t("invoiceIdRequired"),
      });
      return;
    }

  const refundVal = {
    id: val,

    items: cartItems.map((j) =>
      j.itemType === 2
        ? { ...j, productId: "" }
        : j
    ),

    tax,
    cancelType: 2,
    subtotal: subTotal,

    refundType: refundType,

    // Only Return Money has a payment method
    ...(refundType === 1 && {
      refundPayType: Number(refundPayType),
    }),

    userId: _authUser.id,
    storeId: _store.id,
  };

    setLoader(true);
    // 
    const onComplete = (res, err) => {
      safeOnComplete(
        (res) => {
          if (res.status === 201) {
            refreshInventory();

            setAlert({
              isOpen: true,
              type: "success",
              title: t("successful"),
              subTitle: t("refundSuccessful"),
            });
            handleClearCart();
            navigate("/pos");
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: t("warning"),
              subTitle: res.msg,
            });
          }
        },
        (err) => {
          setAlert({
            isOpen: true,
            type: "error",
            title: t("error"),
            subTitle: err.msg,
          });
        }
      )(res, err);

      setLoader(false); // ✅ centralized cleanup
    };
    //

//     console.log("REFUND TYPE:", refundType);
// console.log("REFUND DATA:", refundVal);

    _post(
      endpoints.VoidSell,
      NestedFormData(RmvEmptyProp(refundVal)),
      null,
      onComplete
    );
  };

  const handleInpChange = (e) => {
    setVal(e.target.value);
  };

  const handleNum = (e, val) => {
    setVal((x) => x + (val !== undefined ? val : e.target.innerText));
  };

  const clear = () => {
    setVal("");
  };

  useEffect(() => {
    return () => {
      setVal("");
    };
  }, []);

  return (
    <>
      {/* Display */}
      <Grid className="gray-color mb-20 p-5">
        <Input
          value={val}
          onChange={handleInpChange}
          type="number"
          variant="outlined"
          className="bg-white rmv-arrow br-8 w-100pr"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography className="fw-6 fs-20">{t("invoiceId")}:</Typography>{" "}
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiInputBase-input": {
              fontSize: "28px",
              fontWeight: "600",
              color: "var(--gray-color)",
            },
          }}
        />

        <Button
          onClick={loadInvoice}
          variant="contained"
          fullWidth
          sx={{ mt: 1 }}
        >
          {t("loadInvoice")}
        </Button>

      </Grid>

      <Box
        className="d-flex"
        sx={{
          height: { xs: "calc(100vh - 400px)", md: "calc(100vh - 440px)" },
          flexWrap: { xs: "wrap", md: "inherit" },
        }}
      >
        <Box className="w-100pr d-grid" sx={{ mr: { md: "10px" } }}>
          <Box className="d-flex mb-10">
            <Button
              size="large"
              onClick={handleNum}
              className="w-100pr bg-white gray-color fs-30 mr-10"
            >
              1
            </Button>
            <Button
              size="large"
              onClick={handleNum}
              className="w-100pr bg-white gray-color fs-30 mr-10"
            >
              2
            </Button>
            <Button
              size="large"
              onClick={handleNum}
              className="w-100pr bg-white gray-color fs-30 mr-10"
            >
              3
            </Button>
            <Button
              size="large"
              onClick={handleNum}
              className="w-100pr bg-white gray-color fs-30"
            >
              4
            </Button>
          </Box>

          <Box className="d-flex mb-10">
            <Button
              size="large"
              onClick={handleNum}
              className="w-100pr bg-white gray-color fs-30 mr-10"
            >
              5
            </Button>
            <Button
              size="large"
              onClick={handleNum}
              className="w-100pr bg-white gray-color fs-30 mr-10"
            >
              6
            </Button>
            <Button
              size="large"
              onClick={handleNum}
              className="w-100pr bg-white gray-color fs-30 mr-10"
            >
              7
            </Button>
            <Button
              size="large"
              onClick={handleNum}
              className="w-100pr bg-white gray-color fs-30"
            >
              8
            </Button>
          </Box>

          <Box className="d-flex mb-10">
            <Button
              size="large"
              onClick={handleNum}
              className="w-100pr bg-white gray-color fs-30 mr-10"
            >
              9
            </Button>
            <Button
              size="large"
              onClick={handleNum}
              className="w-100pr bg-white gray-color fs-30 mr-10"
            >
              0
            </Button>
            <Button
              size="large"
              onClick={handleNum}
              className="w-100pr bg-white gray-color fs-30 mr-10"
            >
              .
            </Button>
            <Button
              size="large"
              onClick={clear}
              className="w-100pr bg-white gray-color"
              sx={{ fontSize: { xs: "16px", md: "22px" } }}
            >
              {t("clear")}
            </Button>
          </Box>
        </Box>

        <Box
          className="mb-10"
          sx={{
            width: { xs: "100%", md: "220px" },
            display: { xs: "flex", md: "grid" },
          }}
        >
          <Button
            size="large"
            onClick={() => navigate("/pos")}
            className="bg-white gray-color fs-18"
            sx={{
              mb: { xs: "0px", md: "10px" },
              mr: { xs: "10px", md: "0px" },
            }}
          >
            {t("cancel")}
          </Button>

          <Button
            size="large"
            onClick={handleRefund}
            className="w-100pr bg-error white-color fs-26"
          >
            {t("refundNow")}
          </Button>
        </Box>

        <Box sx={{ mb: 2 }}>
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>{t("refundType")}</InputLabel>

            <Select
              value={refundType}
              label={t("refundType")}
              onChange={(e) => {
                const value = Number(e.target.value);

                setRefundType(value);

              // Customer Credit and Reduce Balance
              // do not return physical money
                if (value === 2 || value === 3) {
                  setRefundPayType("");
                } else {
                  // Return Money defaults to Cash
                  setRefundPayType(1);
                }
              }}
            >
              <MenuItem value={1}>
                {t("returnMoney")}
              </MenuItem>

              <MenuItem value={2}>
                {t("customerCredit")}
              </MenuItem>

              <MenuItem value={3}>
                {t("reduceBalance")}
              </MenuItem>

            </Select>
          </FormControl>

          {refundType === 1 && (
            <FormControl fullWidth size="small">
              <InputLabel>{t("refundMethod")}</InputLabel>

              <Select
                value={refundPayType}
                label={t("refundMethod")}
                onChange={(e) =>
                  setRefundPayType(Number(e.target.value))
                }
              >
                <MenuItem value={1}>{t("cash")}</MenuItem>
                <MenuItem value={2}>{t("card")}</MenuItem>
                <MenuItem value={4}>{t("check")}</MenuItem>
                <MenuItem value={7}>{t("other")}</MenuItem>
              </Select>
            </FormControl>
          )}
        </Box>

      </Box>
    </>
  );
};
const mapStateToProps = (state) => ({
  _authUser: state.pos.authUser,
  _store: state.pos.defStore,
});

const mapActionToProps = {
  _get: actions.get,
  _getById: actions.getById,
  _post: actions.post,
};

export default connect(mapStateToProps, mapActionToProps)(Refund);
